module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 6h-6V2c0-1.106-.894-2-2-2H10C8.894 0 8 .894 8 2v4H2C.894 6 0 6.894 0 8s.894 2 2 2v20c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V10c1.106 0 2-.894 2-2s-.894-2-2-2zM12 4h8v2h-8V4zm2 21a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12zm8 0a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/trash-4.js
// module id = 1458
// module chunks = 14